import { Tabs, TabsProps } from "antd";
import { MainShedules } from "./schedules/MainSchedules";
import { CustomizedSchedules } from "./schedules/CustomizedSchedules";
import { useSearchParams } from "react-router";

export const WorkShedule = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const currentTab = searchParams.get("tab") || "main";

  const items: TabsProps['items'] = [
    {
      key: 'main',
      label: 'Horaire Sems',
      children: <MainShedules currentTab={currentTab}/>,
    },
    {
      key: 'customized',
      label: 'Horaire personnalisé',
      children: <CustomizedSchedules currentTab={currentTab}/>,
    },
  ];
  
  return(
    <Tabs activeKey={currentTab} items={items} onChange={(key) => {
      const params = new URLSearchParams(searchParams);
      params.set("tab", key);
      setSearchParams(params);
    }}/>
  );
};
